import { Link } from 'react-router';
import { Button, Icon, Section, Toggle } from '@efira/ui';

import { useSaveStream, useStream } from '../../api/queries';

/**
 * Быстрые настройки эфира в левой колонке: три тумблера с пояснениями.
 *
 * Секция раскрыта и без выбранной игры - как у эталона: это настройки
 * АККАУНТА, а не игры, и менять их осмысленно до запуска.
 *
 * Каждая строка объясняет, что включает. Три слова без пояснения
 * («Оповещения») заставляют пробовать, чтобы понять, - а пробовать придётся
 * в эфире.
 *
 * ТУМБЛЕРЫ НАСТОЯЩИЕ С ЕДИНИЦЫ 5. У каждого есть свой элемент на оверлее
 * (`apps/overlay/src/stage/StageHost.tsx`), свой ключ раскладки и свой
 * канал микшера. До этого они были честно помечены недоступными: рабочий
 * на вид переключатель, за которым ничего не происходит, хуже отсутствующей
 * возможности.
 *
 * СОСТОЯНИЕ ЖИВЁТ НА СЕРВЕРЕ, а не в браузере: оверлею нужно знать, что
 * рисовать, а браузерное хранилище до него не доходит.
 *
 * ФОРМУЛИРОВКА ОДНА НА НАСТРОЙКУ. Здесь и в окне настроек описан один и тот
 * же тумблер: «вехи» пропали в одном месте, «оверлей» и «кадр» назывались
 * по-разному - сверка деталей 2026-09-20. Тексты сведены к одному.
 */
const ROWS = [
  {
    id: 'reader' as const,
    title: 'Чтец комментариев',
    hint: 'Читает вслух то, что пишут зрители. Голос — в настройках эфира.',
  },
  {
    id: 'alerts' as const,
    title: 'Оповещения',
    hint: 'Карточка на оверлее: подарок, подписка, репост, вход зрителя и вехи.',
  },
  {
    id: 'giftFx' as const,
    title: 'Эффекты подарков',
    hint: 'Полноэкранная анимация на дешёвые подарки, которые TikTok не анимирует сам.',
  },
];

export function StreamSettings() {
  const stream = useStream();
  const save = useSaveStream();
  const values = {
    reader: stream.data?.reader === true,
    alerts: stream.data?.alerts === true,
    giftFx: stream.data?.giftFx === true,
  };

  return (
    <Section
      title="Настройки эфира"
      id="stream-settings"
      actions={
        <Button asChild variant="ghost" size="s" iconOnly>
          <Link to="/app/settings/stream" aria-label="Открыть полные настройки эфира">
            <Icon name="settings" size="sm" />
          </Link>
        </Button>
      }
    >
      <ul className="space-y-3">
        {ROWS.map((row) => (
          <li key={row.id} data-stream-toggle={row.id}>
            <Toggle
              checked={values[row.id]}
              onChange={(next) => {
                save.mutate({ [row.id]: next });
              }}
              label={<span className="text-sm">{row.title}</span>}
              hint={<span className="text-xs">{row.hint}</span>}
            />
          </li>
        ))}
      </ul>
    </Section>
  );
}
